import { useMemo } from "react";
import { useAppSelector } from "../app/hooks";
import * as lodash from 'lodash';

type Props = {
  shopOrderId: string,
}

type CompImageUploadStatus = {
  isShortage: boolean;
  uploadImageCount: number;
};

type UseCompImageUploadStatusResult = {
  compImageUploadStatusMap: Map<string, CompImageUploadStatus>;
};

export const useCompImageUploadStatus = ({ shopOrderId }: Props): UseCompImageUploadStatusResult => {
  const { xml, compImageList } = useAppSelector((state) => ({
    xml: state.xml[shopOrderId],
    compImageList: state.orderPreparation.compImageList,
  }), lodash.isEqual);

  const compImageUploadStatusMap = useMemo(() => {
    const map = new Map<string, CompImageUploadStatus>();
    if (!xml?.orderInfo?.infoData) return map;
    const infoData = xml.orderInfo.infoData;
    const parentSequence = xml.orderInfo.xml.metaModel.parentSequence || [];
    const orderInfoMap = new Map(infoData.map(v => [v.xml.metaModel.id, v]));
    const uploadedFileSet = new Set(compImageList.map(v => `Comp_Real/${v.filename}`));
    for (const seq of parentSequence) {
      const order = orderInfoMap.get(seq.id);
      if (!order) continue;
      // 完成画像入稿のみ
      if (order.xml.viewModel.orderMethod?.id !== "40" || !!order.xml.viewModel.purpose?.id) continue;
      const orderId = order.xml.metaModel.id;
      if (!orderId) continue;
      // アップロード画像数
      let uploadImageCount = 0;
      // 画像欠落フラグ
      let isShortage = false;
      for (const page of order.xml.allOrderPageDataXml) {
        const realPath = page?.viewModel.compositeFileName?.realPath;
        if (!realPath) continue;
        if (uploadedFileSet.has(realPath)) {
          uploadImageCount++;
        } else {
          isShortage = true;
        }
      }
      map.set(orderId, {
        isShortage,
        uploadImageCount,
      });
    }
    return map;
  }, [xml, compImageList]);

  return { compImageUploadStatusMap };
};
